attachEvent('.anchor-module__item', 'click', (ev) => {
  if (ev.target.hash) {
    const topOffset = getOffsetTop(document.querySelector(ev.target.hash));
    const parentElem = ev.target.closest('.anchor-module__inner');
    const navItem = parentElem.querySelectorAll('.anchor-module__item');

    navItem.forEach((el) => {
      el.classList.remove('is-active');
    });

    ev.target.classList.add('is-active');

    scrollToSmoothly(topOffset - 60, 100);
    ev.preventDefault();
  }
});
